<script setup lang="ts">
import type { AudienceTemplate } from '@/views/audience/config/templates.config'

const props = defineProps<{
  template: AudienceTemplate
  fromMarketingFlow?: string
  audienceTemplate?: string
}>()

const { t } = useI18n()
const router = useRouter()
const { send } = useEvent()

const handleCreateAudience = (selectedTemplate: AudienceTemplate) => {
  send('segment', 'segment.template.card_clicked', {
    template_id: selectedTemplate.type
  })

  const query: Record<string, string> = {
    name: t(selectedTemplate.title),
    template: selectedTemplate.type
  }

  if (props.fromMarketingFlow) {
    query.fromMarketingFlow = props.fromMarketingFlow
  }

  router.push({
    name: 'AudienceCreate',
    query
  })
}
</script>

<template>
  <BaseTemplateCard
    :icon="template.icon"
    :title="template.title"
    :description="template.description"
    :is-recommended="template.isRecommended"
    :recommended-text="t('global.recommended')"
    :button-text="t('pages.audience.templatesPage.callToAction')"
    class="h-full"
    @click="handleCreateAudience(template)"
    @action="handleCreateAudience(template)"
  />
</template>
